import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./ReportView.module.css";
import NarvBarLeft from "../../components/NarvBarLeft/NarvBarLeft";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import FooterHomePage from "../../components/footerHomePage/footerHomePage";
import NarvBarLeftPart2 from "../../components/NarvBarLeftPart2/NarvBarLeftPart2";
import {
  ABMOfDocuments,
  EconomicInformation,
  EmployerInformation,
  HeaderReview,
  PoliticalInformation,
  Personalinformation,
  Glossary,
  TableReviewMDR,
  RelationshipWithMutual,
  TerrorismInformationComponent,
  IncomeAndExpenses,
  BundleList,
} from "../../components";
import {
  CompanyInformation,
  TableReviewMDRCompany,
  HeaderReviewCompany,
  PoliticalInformationCompany,
  TerrorismInformationCompanyComponent,
  EconomicInformationCompany,
  RelationshipWithMutualCompany,
  GlossaryCompany,
  ABMOfDocumentsCompanies,
  IncomeAndExpensesCompany,
} from "../../components/Company";

const ReportView = () => {
  const location = useLocation();
  let data = location.state;
  const [isNavBarVisible, setIsNavBarVisible] = useState(true);
  const [isNavBarVisible2, setIsNavBarVisible2] = useState(true);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 0px) and (max-width: 780px)"
    );
    setIsNavBarVisible(!mediaQuery.matches);
    const handler = (event) => setIsNavBarVisible(!event.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 0px) and (max-width: 1024px)"
    );
    setIsNavBarVisible2(!mediaQuery.matches);
    const handler = (event) => setIsNavBarVisible2(!event.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  if (!data) {
    const storedData = sessionStorage.getItem("reportData");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("reportData", JSON.stringify(data));
  }

  return (
    <div className={styles.all}>
      <HeaderLogoIcon />

      <div className={styles.mainContainer}>
        {isNavBarVisible && (
          <div className="lot-flex">
            <NarvBarLeft />
          </div>
        )}
        {isNavBarVisible2 && (
          <div className="lot-flex">
            <NarvBarLeftPart2 />
          </div>
        )}
        <div className={styles.container}>
          <form>
            {data && data.typeCustomer === "Persona Humana" && (
              <HeaderReview data={data} />
            )}

            {data && data.typeCustomer === "Persona Jurídica" ? (
              <>
                <HeaderReviewCompany data={data} />
                <CompanyInformation data={data} />
                <ABMOfDocumentsCompanies data={data} />
                <EconomicInformationCompany data={data} />
                <IncomeAndExpensesCompany data={data} />
                <RelationshipWithMutualCompany data={data} />
                <PoliticalInformationCompany data={data} />
                <TerrorismInformationCompanyComponent data={data} />
                <TableReviewMDRCompany data={data} />
                <GlossaryCompany />
              </>
            ) : (
              <>
                <Personalinformation data={data} />
                <ABMOfDocuments data={data} />
                <BundleList data={data} />
                <EconomicInformation data={data} />
                <IncomeAndExpenses data={data} />
                <EmployerInformation data={data} />
                <RelationshipWithMutual data={data} />
                <PoliticalInformation data={data} />
                <TerrorismInformationComponent data={data} />
                <TableReviewMDR data={data} />
                <Glossary />
              </>
            )}

            <FooterHomePage />
          </form>
        </div>
      </div>
    </div>
  );
};
export default ReportView;
